import { render, staticRenderFns } from "./outcomeStockMovementDetailBox.vue?vue&type=template&id=315f3bb2&"
import script from "./outcomeStockMovementDetailBox.vue?vue&type=script&lang=ts&"
export * from "./outcomeStockMovementDetailBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports